import React from "react";
import { useMsal } from "@azure/msal-react";

export const AccessDenied = () => {
  const { instance } = useMsal();
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center p-12 bg-white border border-gray-200 rounded-2xl max-w-md">
        <div className="text-5xl mb-4">🔒</div>
        <h2 className="font-serif text-gray-900 text-3xl mb-3">Access Restricted</h2>
        <p className="text-gray-700 mb-6 leading-relaxed">Your account has not been authorized to access LexCore. Please contact your system administrator to request access.</p>
        <button onClick={() => instance.logoutPopup()} className="px-6 py-3 bg-transparent border border-gray-200 text-blue-600 hover:text-blue-500 rounded-lg cursor-pointer font-medium transition-colors">Sign Out</button>
      </div>
    </div>
  );
};
